/* eslint-disable array-callback-return */
import axios from "axios";
import moment from "moment";
import Environment from "../environment";
import {
  encryptClientPassword,
  getCookie,
  setCookie,
  removeCookie,
  ssoLogoutUrl,
  sortByField,
} from "../utils/helper";
import { KEY_COOKIE, MAPPING_LOCALES } from "../constants";
import * as Notification from "../Notification";
import { baseCurrencyCode, decimalScaleByCurrency, decimalSeparatorByCurrency, thousandSeparatorByCurrency } from "../utils/Currency";
let isShowErrored = false;

export const SSO_CONFIG = {
  HEADER: {
    APP_TYPE_KEY: "x-app-type",
    APP_TYPE: {
      AIA: 1,
      A2V: 2,
    }
  }
}

const createAxiosService = (url) => {
  const axiosInstance = axios.create({
    baseURL: url,
  });
  axiosInstance.interceptors.request.use((request) => {
    // @ts-ignore
    const user = window?.user;
    const session = localStorage.getItem("USER");
    if (user?.token && session) {
      // @ts-ignore
      request.headers["Authorization"] = `Bearer ${user?.token}`;
    }
    let language = window?.language;
    switch (window?.language) {
      case "ja":
        language = "jp";
        break;
      case "en":
        language = "english";
        break;
      case "zh":
        language = "cn";
        break;
      case "pt":
          language = "pt";
          break;
      case "es":
        language = "es";
        break;
      default:
        language = window?.language;
    }
    request.headers["Accept-Language"] = `${language}`;
    request.headers[SSO_CONFIG.HEADER.APP_TYPE_KEY] = SSO_CONFIG.HEADER.APP_TYPE.A2V;
    request.headers["language"] = `${language}`;
    return request;
  });

  axiosInstance.interceptors.response.use(
    async (response) => {
      if (response.status === 200) {
      }
      if (response.status === 401) {
        console.log("401");
        // Logout
        // @ts-ignore
      }
      return response;
    },
    async (error) => {
      if (error.response) {
        if (error.response?.status === 401) {
          const accessToken = getCookie(
            KEY_COOKIE.AUTH_TOKEN_COOOKIE
          )?.access_token;
          if (error?.response?.data?.error?.message && isShowErrored === false) {
            isShowErrored = true
            Notification.error(error?.response?.data?.error?.message)
          }
          setTimeout(() => {
            const linkLogout = ssoLogoutUrl(accessToken);
            let params = new URLSearchParams(window.location.search);
            let redirect_url = params.get("redirect_uri");
            if (redirect_url) {
              setCookie("redirect_uri", redirect_url);
            }
            removeCookie(KEY_COOKIE.AUTH_TOKEN_COOOKIE);
            removeCookie(KEY_COOKIE.STATUS_VERIFY_PHONE);
            window.location.href = linkLogout;
          }, 2000)
        }
        return {
          status: error.response?.status || 400,
          data: error.response?.data,
        };
      }

      return {
        status: 500,
        data: null,
      };
    }
  );
  return axiosInstance;
};

export const appService = createAxiosService(Environment.OTC_SERVICE_URL);
export const ssoService = createAxiosService(Environment.AUTH_API_URL);
export const marketService = createAxiosService(Environment.MARKET_SERVICE_URL);

function numberWithSpaces(x) {
  try {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  } catch (e) {
    return x;
  }
}

export const formatCurrencyLegacy = (value, length = 8) => {
  try {
    let floatValue = parseFloat(value);
    if (isNaN(floatValue)) {
      return "0";
    }
    if (floatValue < 0.00000001) {
      length = 12;
    }
    const numberStr = new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 13,
    }).format(floatValue);
    const values = numberStr.split(".");
    return `${values[0] ? values[0] : "0"}${values[1] ? "." : ""}${values[1] ? values[1].substring(0, length) : ""
      }`;
  } catch (e) {
    return value;
  }
};

export function getDecimalLengthFromString(numStr) {
  if (typeof numStr !== 'string') return 0;
  const trimmed = numStr.trim();

  const parts = trimmed.split('.');
  if (!parts[1]) return 0;

  const decimalWithoutTrailingZeros = parts[1].replace(/0+$/, '');
  return decimalWithoutTrailingZeros.length;
}

export const formatCurrency = (value, length = null, currency = "") => {
  try {
    if (value == null || isNaN(value)) return '0';
    const lengthFromValue = getDecimalLengthFromString(value.toString());
    if (length === null) {
      length = lengthFromValue;
    }
    
    const prefix = '';
    const suffix = '';
    const decimalScale = length ?? decimalScaleByCurrency(
      baseCurrencyCode(true, currency)
    )
    const thousandSeparator = thousandSeparatorByCurrency(currency);
    const decimalSeparator = decimalSeparatorByCurrency(currency);

    let [intPart, fracPart = ''] = Number(value)
      .toFixed(decimalScale)
      .split('.');

    intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

    let formattedNumber = decimalScale > 0 ? intPart + decimalSeparator + fracPart : intPart;

    return `${prefix}${formattedNumber}${suffix}`;
  } catch (e) {
    console.error("Error formatting currency:", e);
    return '';
  }
};

export const statusSZTConvert = (item) => {
  let status = "";
  switch (item?.status) {
    case 1: {
      status = "Succeeded";
      break;
    }
    default:
      status = '';
      break;
  }
  return status
}
export const statusConvert = (item) => {
  let status = "";
  // eslint-disable-next-line default-case
  switch (item?.status) {
    case 1: {
      status = "Wait for Confirmation";
      break;
    }
    case 2: {
      status = "Waiting for Approval";
      break;
    }
    case 3: {
      status = "Succeeded";
      break;
    }
    case 4: {
      status = "Rejected";
      break;
    }
    case 5: {
      status = "Expired";
      break;
    }
    case 6: {
      status = "Failed";
      break;
    }
    case 7: {
      status = "Cancelled";
      break;
    }
    case 8: {
      status = "Approved";
      break;
    }
    case 9: {
      status = "Processing";
      break;
    }
  }
  return status;
};
export const typeConvert = (item) => {
  let status = "";
  // eslint-disable-next-line default-case
  switch (item?.type) {
    case 1: {
      status = "deposit";
      break;
    }
    case 2: {
      status = "withdraw";
      break;
    }
    case 3: {
      status = "transfer";
      break;
    }
    case 4: {
      status = "Checkout";
      break;
    }
    case 5: {
      status = "Sell Item";
      break;
    }
    case 6: {
      status = "Order Fee";
      break;
    }
    case 7: {
      status = "Service Fee";
      break;
    }
    case 8: {
      status = "Withdrawal Fee";
      break;
    }
    case 11: {
      status = "Subscription Benefit";
      break;
    }
  }
  return status;
};
export const typeConvertSGT = (item) => {
  let status = "";
  switch (item?.type) {
    case 30: {
      status = "SGT Walking Reward";
      break;
    }
    case 31: {
      status = "SGT Buy";
      break;
    }
    case 32: {
      status = "SGT Sell";
      break;
    }
    case 33: {
      status = "SGT Deposit";
      break;
    }
    case 34: {
      status = "SGT Withdraw";
      break;
    }
    case 35: {
      status = "SGT Adjustment";
      break;
    }   
    case 37: {
      status = "Withdraw SGT Fee";
      break;
    }   
    case 36: {
      status = "Reverse SGT Withdrawal";
      break;
    }
    default: 
      status = "";
  }
  return status;
}
export const typeConvertSZT = (item) => {
  let status = "";
  switch (item?.type) {
    case 2: {
      status = "Withdraw";
      break;
    }
    case 3: {
      status = "Buy";
      break;
    }
    case 4: {
      status = "Walking rewards";
      break;
    }
    case 5: {
      status = "Sell";
      break;
    }
    case 9: {
      status = "Admin Deposit";
      break;
    }
    case 10: {
      status = "Deposit";
      break;
    }
    case 11: {
      status = "MLM Deposit";
      break;
    }
    case 12: {
      status = "Scholar walking rewards";
      break;
    }
    case 13: {
      status = `Contract fee`;
      break;
    }
    case 14: {
      status = "Participant reward";
      break;
    }
    case 15: {
      status = "Leader board reward";
      break;
    }
    case 16: {
      status = "Bonus energy";
      break;
    }
    case 17: {
      status = "Refund for customer";
      break;
    }
    case 18: {
      status = "Bonus for staff";
      break;
    }
    case 19: {
      status = "Adjust";
      break;
    }
    case 20: {
      status = "Salary";
      break;
    }
    case 21: {
      status = "Outsource Service";
      break;
    }
    case 22: {
      status = "Event Reward";
      break;
    }
    case 23: {
      status = "SZT bonus type";
      break;
    } 
    case 24: {
      status = "Top up e-Wallet";
      break;
    }
    case 25: {
      status = "Top up e-Wallet fee";
      break;
    }
    case 26: {
      status = "Reverse Top up e-Wallet";
      break;
    }
    case 42: {
      status = `Affiliate commission`;
      break;
    }
    default: 
      status = ''
  }
  return status;
}

export const typeConvertNew = (item) => {
  let status = "";
  switch (item?.type) {
    case 1: {
      status = "Deposit";
      break;
    }
    case 2: {
      status = "Withdrawal";
      break;
    }
    case 3: {
      status = "ETH deposit excess amount";
      break;
    }
    case 5: {
      status = "Internal convert/transfer";
      break;
    }
    case 10: {
      status = `{currency_code} distribution`;
      break;
    }
    case 11: {
      status = `Adjust`;
      break;
    }
    case 12: {
      status = `SOT for affiliate`;
      break;
    }
    case 18: {
      status = `{currency_code} balance correction`;
      break;
    }
    case 19: {
        status = "Distribution for Art Plus";
        break;
    }
    case 20: {
        status="Distribution for AI Subscription";
        break;
    }
    case 21: {
        status="Distribution for Subscription";
        break;
    }
    case 22: {
        status="Distribution for ART PRIME";
        break;
    }
    case 23: {
        status="Adjustment for send NFT Avatar";
        break;
    }
    case 24:{
        status="Adjustment for receive NFT Avatar";
        break;
    }
    case 25: {
        status="Adjustment for pending NFT Avatar";
        break;
    }
    case 36: {
      status = "Transaction fee";
      break;
    }
    case 37: {
      status = "Buy item";
      break;
    }
    case 38: {
      status = "Sell item";
      break;
    }
    case 39: {
      status = "Refund";
      break;
    }
    case 40: {
      status = "Royalty";
      break;
    } 
    case 41: {
      status = "Token revoke";
      break;
    } 
    case 42: {
      status = "Distribute-staff";
      break;
    } 
    case 43: {
      status = "Token revoke-staff";
      break;
    } 
    default: 
      status = ''
  }
  return status;
};

export const errorView = (errors, field) => {
  const error = errors.find((item) => item.key === field);
  return error
    ? {
      validateStatus: "error",
      help: error.value,
    }
    : {};
};

export const filterDataSubTop = (subData, bonusSubData, aiSubData, primeSubData) => {
  const data = [];

  const processItem = (item, isPrime = false) => {
    const endDateMs = Number(item.end_date_ms || item?.sub?.end_date_ms);
    const status = item.status || item?.sub?.status;
    const userCanceled = item.user_canceled ?? item?.sub?.user_canceled;

    if (status === 1 && userCanceled === 0) {
      data.push({
        ...item,
        product_image: item.product_image || item?.sub?.product_image,
        price: item.price || item?.sub?.price,
        currency_code: item.currency_code || item?.sub?.currency_code,
        diffDay: moment(endDateMs).diff(new Date(), "days"),
        end_date: endDateMs,
        status,
        product_name: item.product_name || item?.sub?.product_name,
        product_sku: item.product_sku || item?.sub?.product_sku,
        user_canceled: userCanceled,
        is_prime: isPrime,
      });
    }
  };

  primeSubData?.forEach((item) => processItem(item, true));
  subData?.forEach((item) => processItem(item));
  bonusSubData?.forEach((item) => processItem(item));
  aiSubData?.forEach((item) => processItem(item));

  return sortByField(data, "diffDay", "asc");
};

export function roundNumber(value, exp) {
  if (typeof exp === "undefined" || +exp === 0) return Math.round(value);

  value = +value;
  exp = +exp;

  if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) return NaN;

  // Shift
  value = value.toString().split("e");
  value = Math.round(+(value[0] + "e" + (value[1] ? +value[1] + exp : exp)));

  // Shift back
  value = value.toString().split("e");
  return numberWithSpaces(
    +(value[0] + "e" + (value[1] ? +value[1] - exp : -exp))
  );
}

export const getWalletMLM = () => {
  return appService.get("/wallet/v1/mlm");
};

export const getInfoDashboard = () => {
  return appService.get("/dashboard/v1/home");
};
export const getUserStakeInfo = () => {
  return appService.get("/web3/v1/stake/user/info");
};
export const getStakeTransactions = (params) => {
  return appService.get("/web3/v1/stake/history/transactionsV2", {params});
};
export const getStakeTransactionDetail = (stakeRecordId) => {
  return appService.get(`/web3/v1/stake/details/${stakeRecordId}`);
};

export const getStakeEligible = () => {
  return appService.get("/web3/v1/stake/token/balances");
};
export const getStakeEstimateGas = (params) => {
  return appService.get("/web3/v1/stake/estimate-gas", {params: params});
};
export const getStakeOtp = (params) => {
  return appService.post("/web3/v1/stake/get-email-code", params);
};
export const stakeRequest = (params) => {
  return appService.post("/web3/v1/stake/request", params);
};
export const stakeRequestConfirm = (params) => {
  return appService.post("/web3/v1/stake/confirmV2", params);
};

/**
 * Requests a re-stake
 * @param {Object} body - The re-stake confirmation request body
 * @param {number} body.stakeRecordId - The ID of the stake record to re-stake
 * @param {number} body.amount - The amount to re-stake
 * @returns {Promise<Object>} Promise that resolves to the API response
 * @returns {boolean} returns.success - Whether the re-stake request was successful
 * @returns {string} returns.message - Response message from the API
 */
export const requestReStake = (body) => {
  return appService.post("/web3/v1/stake/request-re-stake", body);
};

/**
 * Confirms a re-stake request
 * @param {Object} body - The re-stake confirmation request body
 * @param {number} body.txId - The ID of the stake record to re-stake
 * @param {string} body.emailCode - The email code to re-stake
 * @param {string} body.twofaCode - The two-factor authentication code to re-stake
 * @returns {Promise<Object>} Promise that resolves to the API response
 * @returns {boolean} returns.success - Whether the re-stake confirmation was successful
 * @returns {string} returns.message - Response message from the API
 */
export const confirmReStake = (body) => {
  return appService.post("/web3/v1/stake/confirm-re-stake", body);
};

/**
 * 
 * @param {Object} body - The claim staking request body
 * @param {string} body.stakeRecordId - The stake record ID to claim
 * @returns {Promise<Object>} Promise that resolves to the API response
 */
export const claimStakingRequest = (body) => {
  return appService.post("/web3/v1/stake/request-claim", body);
};

/**
 * Confirms a claim staking request
 * @param {Object} body - The claim staking confirmation request body
 * @param {string} body.txId - The transaction ID to claim
 * @param {string} body.emailCode - The email code to claim
 * @param {string} body.twofaCode - The two-factor authentication code to claim
 * @returns {Promise<Object>} Promise that resolves to the API response
*/
export const confirmClaimStakingRequest = (body) => {
  return appService.post("/web3/v1/stake/confirm-claim", body);
};

/**
 * Updates the auto subscribe stake
 * @param {Object} body - The auto subscribe stake request body
 * @param {string} body.stakeRecordId - The stake record ID to update
 * @param {boolean} body.autoSubscribe - The auto subscribe stake value
 * @returns {Promise<Object>} Promise that resolves to the API response
 */
export const updateAutoSubscribeStake = (body) => {
  return appService.put("/web3/v1/stake/auto-subscribe", body);
};

export const transferWalletMLM = ({ destCurrencyCode, amount }) => {
  return appService.post("/transaction/v1/transfer-mlm", {
    destCurrencyCode,
    amount,
  });
};

export const sendOTPVerify = () => {
  return appService.post("common/v1/otp/send");
};

export const resendOTPVerify = (verify_request_id) => {
  return appService.post("common/v1/otp/resend", { verify_request_id });
};

export const confirmOTPVerify = ({
  verify_request_id,
  otp_code,
  password = undefined,
  twofa_code = undefined,
}) => {
  return appService.post("common/v1/otp/confirm", {
    verify_request_id,
    otp_code,
    password,
    twofa_code,
  });
};

export const postCheckIsExistEmail = (email) => {
  return appService.post("/member/v1/login-step1", { email });
};

export const postLoginPassword = (email, password) => {
  return appService.post("/member/v1/login-by-password", { email, password });
};

export const getSettingInstagram = () => {
  return appService.get("/common/v1/sys-data?code=ENABLE_INSTAGRAM_LOGIN");
};

export const getSettingByCode = (code) => {
  return appService.get(`/common/v1/sys-data?code=${code}`);
};

export const postPhoneSentCodeVerify = (countryCode, phone) => {
  return appService.post("/member/v1/resend-phone-verification-code", {
    countryCode,
    phone,
  });
};
export const postPhoneVerify = (code) => {
  return appService.post("/member/v1/confirm-phone-verification-code", {
    verifyCode: code,
  });
};

export const postSkipPhoneVerify = () => {
  return appService.put("/member/v1/skip-verify-phone");
};

export const postCheckPhoneVerify = (fromWalletId) => {
  return appService.post("/transaction/v1/transfer-check-verification-phone", {
    fromWalletId,
  });
};
export const getPhoneCodes = () => {
  return appService.get("/common/v1/phone-prefixes");
};
export const postLoginOTP = (email, otp) => {
  return appService.post("/member/v1/login-by-verification-code", {
    email,
    verificationCode: otp,
  });
};
export const postSentOTP = (email) => {
  return appService.post("/member/v1/resend-verification-code", { email });
};
export const getUserLanguage = () => {
  return appService.get("/member/v1/languages", {});
};
export const postUserLanguage = (language) => {
  let langePost = language;
  if (language === "ja") {
    langePost = "jp";
  }
  if (language === "en") {
    langePost = "english";
  }
  return appService.post("/member/v1/choose-language", {
    language: langePost,
  });
};
export const getCurrenciesList = (types = [1, 2]) => {
  return appService.post("/common/v1/currencies", { type: types });
};

export const getCurrenciesBaseList = (types = [3]) => {
  return appService.post("/common/v1/currencies", { type: types });
};

export const getCurrenciesRate = () => {
  return appService.get("/common/v1/currency-rates");
};
export const getCurrenciesRateV2 = (currencies, localCurrencies) => {
  const symbols = [];
  [...currencies, { code: "BTC" }].map((x) => {
    localCurrencies.map((y) => {
      symbols.push(x.code + y);
    });
  });
  return marketService
    .post("/rate/best-rate", {
      symbols,
      companyId: 1,
    })
    .then((result) => {
      if (result?.status === 200) {
        const data = result?.data?.data?.map((x) => {
          const code =
            x?.symbolName
              ?.split("")
              ?.reverse()
              ?.join("")
              ?.replace("YPJ", "")
              ?.replace("DSU", "")
              ?.split("")
              ?.reverse()
              ?.join("") || "";
          const local = x?.symbolName?.replace(code, "") || "";
          return {
            ...x,
            ask_amount: x.aid,
            bid_amount: x.bid,
            from_currency_code: code,
            from_currency_id: null,
            id: null,
            to_currency_code: local,
            to_currency_id: null,
          };
        });
        result.data.data = data;
        return result;
      }
      return null;
    });
};

export const handleSignupStep1 = (values) => {
  return appService.post("/member/v1/sso/sign-up-request", {
    ...values,
    password: encryptClientPassword(values.password),
  });
};

export const handleFinishSignupStep3 = (values) => {
  return appService.post("/member/v1/sso/sign-up-confirm", {
    ...values,
  });
};

export const resendOtpSignupStep2 = ({ request_id }) => {
  return appService.post("/member/v1/sso/sign-up-resendotp", {
    request_id,
  });
};

export const getWalletList = (params = {}) => {
  return appService.get("/wallet/v1/search", { params });
};

export const getWalletListSzt = (params = {}) => {
  return appService.get("/wallet/v1/game", { params });
};
export const getWalletListSgt = (params = {}) => {
  return appService.get("/wallet/v1/game-sgt", { params });
};
export const getWalletListOption = (params = {}) => {
  return appService.post("/wallet/v1/option", params);
};
export const getWalletOptionDetail = (params = {}) => {
  return appService.post("/wallet/v1/option/detail", params);
};


export const getWallet = (id) => {
  return appService.get(`/wallet/v1/${id}`);
};
export const getTransactionList = (params) => {
  return appService.get(`/transaction/v1/search`, { params: {
    ...params,
    ignoreFiat: true
  } });
};
export const getCashflowList = (data) => {
  return appService.post(`/cashflow/v1/search`, data);
};
export const getAddressBookList = (data) => {
  return ssoService.post(`/connect/search-wallet-address`, data);
};
export const deleteAddressBook = (data) => {
  return ssoService.post(`/connect/delete-wallet-address`, data);
};
export const createAddressBook = (data) => {
  return ssoService.post(`/connect/create-wallet-address`, data);
};
export const updateAddressBook = (data) => {
  return ssoService.post(`/connect/update-wallet-address`, data);
};
export const getCashflowOption = (data) => {
  return appService.post(`/cashflow/v1/search-option`, data);
};
export const getCashflowListSZT = (data) => {
  return appService.post(`/cashflow/v1/search-szt`, data);
};
export const getCashflowListSGT = (data) => {
  return appService.post(`/cashflow/v1/search-sgt`, data);
};
export const getCashflowDetail = (transactionId) => {
  return appService.post(`/cashflow/v1/detail`, { transactionId: transactionId});
};
export const getProfile = (option = {}) => {
  return appService.get(`/member/v1/me`, option);
};
export const getTransaction = (id) => {
  return appService.get(`/transaction/v1/${id}`, {});
};
export const postConvert = (data) => {
  return appService.post(`/transaction/v1/transfer`, data);
};
export const postWithdraw = (data) => {
  return appService.post(`/transaction/v1/withdraw-request`, data);
};
export const postMintNft = (data) => {
  return appService.post(
    `/nft/v1/mint?network=polygon`,
    data
  );
};
export const postChangeDescriptionNft = (data) => {
  return appService.post(`/nft/v1/info/change-description`, data);
};
export const postChangeNameNft = (data) => {
  return appService.post(`/nft/v1/info/rename`, data);
};
export const getDexWallet = () => {
  return appService.get(`/wallet/v1/get-dex-address`);
};
export const postTransferWeb3 = (data) => {
  return appService.post(`/transaction/v1/tranfer-dex-request`, data);
};
export const createDexWallet = () => {
  return appService.post(`/wallet/v1/dex-create`);
};

export const getCommissionByMonth = () => {
  return appService.get("/affiliate/v1/property-history");
}

export const getBonusDetail = () => {
  return appService.get("/affiliate/v1/bonus-detail")
}
export const getSSOMLM = () => {
  return appService.get("/affiliate/v1/sso-url")
}
export const getEverflow = () => {
  return appService.get("/affiliate/v1/dashboard")
}

export const getListOffers = () => {
  return appService.get(`/affiliate/v1/offers`)
}

export const generateTracking = (body) => {
  return appService.post("/affiliate/v1/generate-tracking", body)
}

export const postCreateWallet = (currencyCode) => {
  return appService.post(`/wallet/v1/address`, { currencyCode });
};
export const postWithdrawSendCode = (transactionId, otp_method = "email") => {
  return appService.post(`/transaction/v1/withdraw-send-code`, {
    transactionId,
    otp_method
  });
};
export const postClaimSendCode = (params) => {
  return appService.post(`/transaction/v1/claim-send-code`, params);
};

export const getInfoByCodeSSO = (code) => {
  return appService.post(`/member/v1/sso/get-info-by-code`, {
    code: code,
    type: "authorization_code",
  });
};

export const postWithdrawConfirm = (data) => {
  return appService.put(`/transaction/v1/withdraw-confirm`, data);
};

export const postWithdrawConfirmV2 = (data) => {
  return appService.put(`/transaction/v1/withdraw-confirmV2`, data);
};

export const postClaimConfirm = (data) => {
  return appService.post(`/transaction/v1/claim-confirm`, data);
};
export const postWithdrawCancel = (data) => {
  return appService.put(`/transaction/v1/withdraw-cancel`, data);
};
export const getConvertFee = (amount, currencyCode) => {
  return appService.get(`/transaction/v1/transfer-calculate-fee`, {
    data: { amount, currencyCode },
    params: { amount, currencyCode },
  });
};
export const getConvertNote = (from, to) => {
  return appService.get(`/transaction/v1/get-config-rate`, {
    params: {
      fromCurrencyCode: from,
      destCurrencyCode: to,
    },
  });
};
export const getWithdrawFee = (amount, currencyCode) => {
  return appService.get(`/transaction/v1/withdraw-calculate-fee`, {
    data: { amount, currencyCode },
    params: { amount, currencyCode },
  });
};
export const getWithdrawSGTFee = (amount) => {
  return appService.get(`/transaction/v1/withdraw-sgt-calculate-fee`, {
    params: { amount },
  });
};
export const withdrawSgtRequest = (params) => {
  return appService.post(`/transaction/v1/withdraw-sgt-request`, params);
};
export const withdrawSgtSendCode = (params) => {
  return appService.post(`/transaction/v1/withdraw-sgt-send-code`, params);
};
export const withdrawSgtSendConfirm = (params) => {
  return appService.put(`/transaction/v1/withdraw-sgt-confirm`, params);
};

export const getTwoFactorStep1 = () => {
  return appService.post(`/member/v1/twofactor-generate-step1`, {});
};

export const getTwoFactorStep2 = (code) => {
  return appService.post(`/member/v1/twofactor-generate-step2`, { code });
};

export const getTwoFactorDisable = (code) => {
  return appService.post(`/member/v1/twofactor-disable`, { code });
};

export const getTwoFactorVerify = (code) => {
  return appService.post(`/member/v1/twofactor-verify`, { code });
};
export const getGameCurrencyStatistics = (id = null) => {
  return appService.get(`report/v1/game-currency-statistics`, {});
};

export const openApp = async (data) => {
  const { API_KEY, PACKAGE_ANDROID, PACKAGE_IOS, DOMAIN_URI_PREFIX } =
    Environment;
  const currentUrl = window.location.href.toString();

  const result = await axios.post(
    `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${API_KEY}`,
    {
      dynamicLinkInfo: {
        domainUriPrefix: `${DOMAIN_URI_PREFIX}`,
        link: currentUrl || "",
        androidInfo: {
          androidPackageName: `${PACKAGE_ANDROID}`,
        },
        iosInfo: {
          iosBundleId: `${PACKAGE_IOS}`,
        },
        navigationInfo: {
          enableForcedRedirect: 1,
        },
      },
    }
  );
  if (result?.status === 200) {
    return result?.data?.shortLink;
  }
  return null;
};

export const postAppleAuth = async () => {
  const response = await window.AppleID.auth.signIn().catch((error) => {
    return null;
  });
  return response;
};
export const postAppleAuth2 = (code) => {
  return appService.post(`/member/v1/login-by-apple`, { code });
};
export const postAppleAuth3 = (code) => {
  return appService.post(`/member/v1/create-by-apple`, { code });
};

export const postInstagramAuth2 = (code, redirectUri) => {
  return appService.post(`/member/v1/login-by-instagram`, {
    code,
    redirectUri,
  });
};
export const postInstagramAuth3 = (code, redirectUri) => {
  return appService.post(`/member/v1/create-by-instagram`, {
    accessToken: code,
  });
};

export const postFacebookAuth = async () => {
  let resultLogin = null;
  resultLogin = await new Promise((resolve, reject) => {
    try {
      window.FB.getLoginStatus(function (response) {
        resolve(response?.authResponse);
      });
    } catch (e) {
      resolve(null);
    }
  });
  if (!resultLogin) {
    resultLogin = await new Promise((resolve, reject) => {
      try {
        window.FB.login(
          function (response) {
            resolve(response?.authResponse);
          },
          { scope: "public_profile,email" }
        );
      } catch (e) {
        resolve(null);
      }
    });
  }
  return resultLogin;
};

export const postFacebookAuth2 = (code) => {
  return appService.post(`/member/v1/login-by-facebook`, { code });
};

export const postFacebookAuth3 = (code) => {
  return appService.post(`/member/v1/create-by-facebook`, { code });
};

export const postGoogleAuth2 = (code) => {
  return appService.post(`/member/v1/login-by-google`, { code });
};

export const postGoogleAuth3 = (code) => {
  return appService.post(`/member/v1/create-by-google`, { code });
};

export const postSentEmailCodeVerify = (email, options = {}) => {
  return appService.post(
    `/member/v1/social-resend-verification-code`,
    {
      email,
    },
    options
  );
};
export const postEmailCodeVerify = (verificationCode, options = {}) => {
  return appService.post(
    `/member/v1/social-verification-email`,
    {
      verificationCode,
    },
    options
  );
};

export function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email || "");
}

//asset 
export const summaryGift = (params) => {
  return appService.post(
    `/item/v1/summaryGift`,
    params,
  );
};
export const summaryEnergy = () => {
  return appService.get(
    `/item/v1/energy`
  );
};

export const itemsSearch = (params) => {
  if (params.levels && params.levels.length === 0) delete params.levels;
  if (params.rankCode && params.rankCode.length === 0) delete params.rankCode;
  if (params.categories && params.categories.length === 0) delete params.categories;
  if (params.breeds && params.breeds.length === 0) {
    delete params.breeds;
  }else{
    params.collections = params.breeds
  }
  if (params.genders && params.genders.length === 0) delete params.genders;
  if (
    !params.isMintNft ||
    params.isMintNft.length === 0 ||
    params.isMintNft.length === 2
  )
    delete params.isMintNft;
  if (!params.name) delete params.name;
  if (!params.priceFrom && params.priceFrom !== "0") {
    delete params.priceFrom;
  } else {
    params.priceFrom = parseFloat(params.priceFrom)
  }
  if (!params.priceTo && params.priceTo !== "0") {
    delete params.priceTo;
  } else {
    params.priceTo = parseFloat(params.priceTo);
  }
  if (params?.isMintNft?.length === 1) {
    if (params?.isMintNft?.[0] === "1") {
      params.isNotNFT = true
    }
    if (params?.isMintNft?.[0] === "2") {
      params.isNFT = true;
    }
    delete params?.isMintNft
  }
  if (
    !params?.tagNFT || params?.tagNFT?.includes("") || (params?.tagNFT?.includes("motion")  && params?.tagNFT?.includes("photo"))
  ) {
    delete params.tagNFT;
  } else {
    params.tagNFT = params?.tagNFT?.[0];
  }
  if (params?.skus?.length >= 1 && params?.skus?.includes("")) {
    delete params?.skus
  }
  return appService.post(
    `/item/v1/search`,
    params,
  );
};
export const itemsBreed = (type) => {
  return appService.get(`/item/v1/breeds?type=${type}`);
};

export const itemsSku = (type) => {
  return appService.post(`/item/v1/sku`, {itemTypes: [type]});
};
export const itemsRank = () => {
  return appService.get(`/common/v1/item/rank-code`);
};
export const animations = () => {
  return appService.get(`/item/v1/animations?type=2`);
};
export const itemsLevels = () => {
  return appService.get(
    `/item/v1/levels`
  );
};
export const itemDetail = (id) => {
  return appService.get(
    `/item/v1/detail/${id}`
  );
};
export const itemsMyPurchase = (params) => {
  return appService.post(
    `/transaction/v1/my-purchase`,
    params
  );
};
export const querySubscription = () => {
  return appService.post(
    `/item/v1/querySubscription`
  );
};
export const querySubCard = () => {
  return appService.post(
    `/item/v1/querySubCard`
  );
};
export const modifyShopifyPayment = (card_info) => {
  return appService.post(
    `/item/v1/modifyShopifyPayment`, {card_info}
  );
};
export const cancelSubscription = (id) => {
  return appService.post(
    `/item/v1/cancelSubscription?id=${id}`
  );
};
export const cancelSubShopifyScription = (id) => {
  return appService.post(
    `/item/v1/cancelShopifySub`, {sub_id: id}
  );
};
export const modifyPayment = (id) => {
  return appService.post(
    `/item/v1/modifyPayment?id=${id}`
  );
};
export const itemMove = (params) => {
  return appService.post(
    `/item/v1/move`, params
  );
};
export const queryGift = (params) => {
  return appService.post(
    `/item/v1/queryGift`, params
  );
};
export const claimGift = (params) => {
  return appService.post(
    `/item/v1/claimGift`, params
  );
};
export const itemDetailMarket = (token) => {
  return appService.get(`${Environment.MARKET_SERVICE_URL}/shopify/v2/itemDetailToken/${token}?detail=0`);
};

export const ssoGetConfig = (key) => {
  return appService.get(`${Environment.SSO_API_URL}/get-config?key=${key}`);
};

export const ssoIsNewPasswordFlagOn = async () => {
  const key = "new_password_flag";
  try {
    const res = await ssoGetConfig(key);
    const flag = res?.data?.data?.NEW_PASSWORD_STANDARD_FLAG;
    return !!flag;
  } catch (err) {
    console.log("Error fetching new password flag:", err);
    return false;
  }
}

export const ssoCheckPassword = (params) => {
  return appService.post(`${Environment.SSO_API_URL}/profile/check-password`, params);
}

export const ssoUpdatePassword = (params) => {
  return appService.post(`${Environment.SSO_API_URL}/profile/change-password`, params);
};

export const ssoSendOtpUpdatePassword = (params) => {
  params = {
    ...params,
    type: 1,
  }

  return appService.get(
    `${Environment.SSO_API_URL}/get-otp`,
    {params},
  );
}

export const ssoSetPasswordRequest = () => {
  return appService.post(
    `${Environment.AUTH_API_URL}/account/request-set-password`,
    {},
  );
};export const ssoSetPasswordVerifyOtp = (params) => {
  return appService.post(
    `${Environment.AUTH_API_URL}/account/verify-set-password`,
    params
  );
};
export const ssoSetPassword = (params) => {
  return appService.post(
    `${Environment.AUTH_API_URL}/account/confirm-set-password`,
    params,
  );
};
export const ssoUpdateProfile = (params) => {
  return appService.post(`${Environment.SSO_API_URL}/profile`, params);
};
export const ssoVerify2FA = (params) => {
  return appService.post(`${Environment.SSO_API_URL}/twofactor-verify`, params);
};
export const ssoGetUserInfo = () => {
  return appService.get(`${Environment.SSO_API_URL}/userinfo`);
};
export const getCollectionUrl = () => {
  return appService.get(`/affiliate/v1/collections-url`);
};
export const genAffByCategory = (params) => {
  return appService.post(`/affiliate/v1/generate-tracking-category`, params);
};
export const genAffByProduct = (params) => {
  return appService.post(`/affiliate/v1/generate-tracking-product`, params);
};

export const agreePolicy = (params) => {
  return appService.put(`/affiliate/v1/agree-policy`, params);
};

export const linkSocialAccount = async (data, locale) => {
  try {
    const res = await appService.post(`${Environment.SSO_API_URL}/link-${data.provider}`, {
      code: data.code
    }, {
      headers: {
        'accept-language': MAPPING_LOCALES[locale],
        [SSO_CONFIG.HEADER.APP_TYPE_KEY]: SSO_CONFIG.HEADER.APP_TYPE.A2V,
        'platform': 'web'
      },
    })
    return res.data;
  } catch (err) {
    return err.data ? err.data : { status: false, message: err.message };
  }
};

export const unlinkSocialAccount = async (data, locale) => {
  try {
    const res = await appService.post(`${Environment.SSO_API_URL}/unlink-${data.provider}`, {
      code: data.code
    }, {
      headers: {
        'accept-language': MAPPING_LOCALES[locale],
        [SSO_CONFIG.HEADER.APP_TYPE_KEY]: SSO_CONFIG.HEADER.APP_TYPE.A2V,
      }
    })
    return res.data;
  } catch (err) {
    return err.data ? err.data : { status: false, message: err.message };
  }
};
export const ssoVerifyPhoneRequest = async (data, locale) => {
  try {
    const res = await appService.post(`${Environment.SSO_API_URL}/verify-phone-request`, data, {
      headers: {
        'accept-language': MAPPING_LOCALES[locale]
      }
    })
    return res.data;
  } catch (err) {
    return err.data ? err.data : { status: false, message: err.message };
  }
};
export const ssoVerifyPhoneConfirm = async (data, locale) => {
  try {
    const res = await appService.post(`${Environment.SSO_API_URL}/verify-phone-confirm`, data, {
      headers: {
        'accept-language': MAPPING_LOCALES[locale]
      }
    })
    return res.data;
  } catch (err) {
    return err.data ? err.data : { status: false, message: err.message };
  }
};
export const getPreviewData = async (url) => {
  try {
    const res = await appService.post(
      `${process.env.REACT_APP_PREVIEW_API_URL}`,
      { q: url },
      {
        headers: {
          "X-Linkpreview-Api-Key": `${process.env.REACT_APP_PREVIEW_API_KEY}`,
        },
      }
    );
    return res.data;
  } catch (err) {
    return null;
  }
};

export const getWeb3OwnerProof = (address) => {
  return appService.get(
    `/web3/v1/owner-proof?walletAddress=${address}`
  );
}

export const verifyWeb3OwnerProof = (address, signature) => {
  return appService.post(
    `/web3/v1/owner-proof`,
    {
      walletAddress: address,
      signature: signature
    }
  );
}
export const checkCountryAgeEligibility = async () => {
  try {
    const res = await appService.post(
    `/country-age-range/v1/eligibility`
    );
    // Check if status is in 2xx range
    if (!res.status || res.status < 200 || res.status >= 300) {
      throw new Error("Failed to check country age eligibility");
    }
    return res.data;
  } catch (err) {
    throw err;
  }
}

export const checkCountryAgeEligibilityForAffiliate = async () => {
  try {
    const res = await appService.post(
    `/country-age-range/v1/eligibility-for-affiliate`
    );
    // Check if status is in 2xx range
    if (!res.status || res.status < 200 || res.status >= 300) {
      throw new Error("Failed to check country age eligibility");
    }
    return res.data;
  } catch (err) {
    throw err
  }
}

export const CHECK_AGE_ELIGIBILITY_CODE = {
  USER_AGE_NOT_FOUND: 1001,
  COUNTRY_NOT_SETTING_AGE_RANGE: 1003,
  USER_AGE_NOT_ELIGIBLE: 1004,
}

export const getWeb3OwnerProofsByUser = () => {
  return appService.get(
    `/web3/v1/dex-owner-proofs`
  );
}

export const connectLineOtpByCode = (data) => {
  return ssoService.post(
    `/connect/connect-line-otp-by-code`,
    data
  );
}

export const connectLineOtp = (data) => {
  return ssoService.post(
    `/connect/connect-line-otp`,
    data
  );
}

export const postUserLastAccess = (moduleKey = "ams") => {
  return ssoService.post(
    `/connect/users/last-access`,
    { module_key: moduleKey }
  );
}

export const checkExistLineOtpByCode = (code) => {
  return ssoService.post(
    `/connect/existence-line-otp-by-code`,
    { code }
  );
}

export const disconnectLineOtp = () => {
  return ssoService.put(
    `/connect/disconnect-line-otp`
  );
}

export const changeOtpMethod = (otpMethod) => {
  return ssoService.put(
    `/connect/change-otp-method`,
    {
      otp_method: otpMethod
    }
  );
}

export const getOtpMethodByEmail = (email) => {
  return ssoService.get(
    `/public/otp-method/get-by-email?email=${encodeURIComponent(email)}`
  );
}

export const getAuthCode = () => {
  return appService.get(`/member/v1/get-auth-code`);
}

export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return appService.post(`/common/v1/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
